// extracted by mini-css-extract-plugin
module.exports = {"popup":"ConfirmationPopup__popup--2Tv","inner":"ConfirmationPopup__inner--3vS","content":"ConfirmationPopup__content--2kg","btn":"ConfirmationPopup__btn--3zI"};